<template>
  <a-modal v-model="visible" :footer="null" title="已关联资源" @ok="visibleOk" @cancel="visibleCancel" width="50%">
    <div class="modal-body">
      <a-spin :spinning="loading">
        <a-row type="flex" justify="end" v-if="list.length > 0">
          <a-button @click="openResource">添加资源</a-button>
        </a-row>
        <a-row v-if="list.length">
          <a-row>
            <a-col v-for="item in columns" :key="item.prop" :span="item.span" class="table-th">{{ item.label }}</a-col>
          </a-row>
          <a-row v-for="(item, index) in list" :key="item.id">
            <a-col v-for="column in columns" :key="column.prop" :span="column.span" class="table-td">
              <span v-if="column.prop === 'action'" @click="cancelAssociation(item)" class="action-text">取消关联</span>
              <span v-if="column.prop == 'type'">{{ getType(item.name) }}</span>
              <div v-if="column.prop == 'name'" style="width: 80%">
                <div class="input-box">
                  <input class="table-input" ref="editRef" maxlength="30" :value="getName(item.name)" @blur="saveName(item, $event)" />
                  <!-- <span>{{ item.name }}</span>-->
                  <a-icon type="edit" class="icon" @click="edit(index)"></a-icon>
                </div>
                <div>{{ item.absolutePath }}</div>
              </div>
            </a-col>
          </a-row>
        </a-row>
        <a-row v-else>
          <a-col class="empty-res">暂无关联资源，<span @click="openResource">立即关联</span></a-col>
        </a-row>
      </a-spin>
    </div>
    <SelectResource ref="SelectResourceRef" :select="list" :exclude="[5, 0, 2, 3]" />
  </a-modal>
</template>
<script>
import SelectResource from './SelectResource'
export default {
  name: 'AssociationModal',
  components: { SelectResource },
  filters: {},
  data() {
    return {
      visible: false,
      loading: false,
      columns: [
        {
          label: '资源名称',
          prop: 'name',
          span: 12,
        },
        {
          label: '资源类型',
          prop: 'type',
          span: 6,
        },
        {
          label: '操作',
          prop: 'action',
          span: 6,
        },
      ],
      list: [],
    }
  },
  methods: {
    edit(index) {
      this.$refs['editRef'][index].focus()
    },
    getType(val='') {
      const arr = val.split('.')
      return arr.at(-1)
    },
    getName(val='') {
      const arr = val.split('.').slice(0, -1)
      return arr.join('.')
    },
    showModal(parmas) {
      return new Promise((res, rej) => {
        this._res = res
        this._rej = rej
        this.visible = true
        this._params = parmas
        this.getList()
      })
    },
    async getList() {
      const params = {
        CourseId: this._params.courseId,
        CourseSessionId: this._params.childCourseId,
      }
      this.loading = true
      const res = await this.$http.CourseResource.courseMaterialList(params).finally(() => (this.loading = false))
      this.list = res.data
      this.$emit('changeCount', this.list)
    },
    visibleOk() {},
    visibleCancel() {
      console.log('---')
      this.visible = false
    },
    cancelAssociation(item) {
      this.$confirm({
        title: '取消关联资源',
        content: '取消关联后课时将不再关联此资源',
        width: '450px',
        centered: true,
        okText: '确认取消',
        okType: 'danger',
        onOk: async () => {
          const data = await this.$http.CourseResource.courseMaterialDelete(item.id)
          this.$message.success('操作成功')
          this.getList()
        },
      })
    },
    async saveName(item, e) {
      const value = e.target.value
      if (value === this.getName(item.name)) return
      if (!value && value !== 0) {
        e.target.value = this.getName(item.name)
        this.$message.error('资源名称不能为空')
        return
      }
      console.log(item.name)
      const fm = new FormData()
      fm.append('materialId', item.id)
      fm.append('name', value + '.' + this.getType(item.name))
      const data = await this.$http.CourseResource.courseMaterialRename(fm)
      this.$message.success('修改成功')
      this.getList()
    },
    async openResource() {
      if (this.list.length >= 5) {
        return this.$message.error('已关联五个资源，请取消关联资源后再添加')
      }
      const { keys, rows } = await this.$refs['SelectResourceRef'].showModal({ childCourseId: this._params.childCourseId })
      const params = {
        courseId: +this._params.courseId,
        childCourseId: +this._params.childCourseId,
        files: rows.map((v, i) => ({
          fileResourceId: v.id,
          fileName: v.name + '.' + v.fileName.match(/\.(.+)$/)[1],
          sortIndex: i,
        })),
      }
      this.loading = true
      const data = await this.$http.CourseResource.courseMaterialAdd(params).finally(() => (this.loading = false))
      this.$message.success('添加成功')
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
.empty-res {
  font-size: 28px;
  color: #8f8a8a;
  text-align: center;
  height: 300px;
  line-height: 300px;
  span {
    color: var(--color);
    cursor: pointer;
  }
}
.action-text {
  color: var(--color);
  font-size: 14px;
  cursor: pointer;
}
.table-th {
  font-size: 14px;
  color: #1c1c1c;
}
.table-td {
  font-size: 14px;
  color: #909090;
  height: 60px;
  display: flex;
  align-items: center;
}
.modal-body {
  min-height: 300px;
}
.table-input {
  border: none;
  //   border-bottom:1px solid #8f8a8a;
  width: 100%;
  height: 100%;
  display: block;
  background: transparent;
  outline: none;
  text-align: start;
  outline: none;
  padding: 0;
}
.table-input ::v-deep input:focus {
  border: none;
  outline: none;
}
.input-box {
  align-items: center;
  display: flex;
  .icon {
    cursor: pointer;
  }
}
</style>
